import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import * as THREE from "three";
import { useNavigate } from "react-router-dom";
import "./css/main.login.css";
import Register from "../register/Register";

const Login: React.FC = () => {
  const Cookies = require("js-cookie");
  const navagate = useNavigate();

  const [isShowLoginForm, setIsShowLoginForm] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    let scene: THREE.Scene,
      camera: THREE.PerspectiveCamera,
      renderer: THREE.WebGLRenderer;
    const LINE_COUNT = 1000;
    const geom = new THREE.BufferGeometry();
    geom.setAttribute(
      "position",
      new THREE.BufferAttribute(new Float32Array(6 * LINE_COUNT), 3)
    );
    geom.setAttribute(
      "velocity",
      new THREE.BufferAttribute(new Float32Array(2 * LINE_COUNT), 1)
    );
    const pos = geom.getAttribute("position");
    const pa = pos.array;
    const vel = geom.getAttribute("velocity");
    const va = vel.array;

    const initParticles = () => {
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(
        60,
        window.innerWidth / window.innerHeight,
        1,
        1000
      );
      camera.position.z = 500;
      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setSize(window.innerWidth, window.innerHeight);
      renderer.setClearColor(0x000000, 0);
      document.body.appendChild(renderer.domElement);

      for (let i = 0; i < LINE_COUNT; i++) {
        const x = Math.random() * window.innerWidth - window.innerWidth / 2;
        const y = Math.random() * window.innerHeight - window.innerHeight / 2;
        const z = Math.random() * 200 - 100;

        pa[6 * i] = x;
        pa[6 * i + 1] = y;
        pa[6 * i + 2] = z;
        pa[6 * i + 3] = x;
        pa[6 * i + 4] = y;
        pa[6 * i + 5] = z;

        va[2 * i] = 0;
        va[2 * i + 1] = 0;
      }

      const mat = new THREE.LineBasicMaterial({ color: 0x008080 });
      const lines = new THREE.LineSegments(geom, mat);
      scene.add(lines);
      window.addEventListener("resize", onWindowResize, false);
      animateParticles();
    };

    const onWindowResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    };

    const animateParticles = () => {
      for (let i = 0; i < LINE_COUNT; i++) {
        va[2 * i] += 0.03;
        va[2 * i + 1] += 0.025;
        pa[6 * i + 2] += va[2 * i];
        pa[6 * i + 5] += va[2 * i + 1];

        // Reset particle nếu vượt qua chiều cao của viewport
        if (pa[6 * i + 5] > 100) {
          const z = Math.random() * 200 - 100;
          const x = Math.random() * window.innerWidth - window.innerWidth / 2;
          const y = Math.random() * window.innerHeight - window.innerHeight / 2;

          pa[6 * i] = x;
          pa[6 * i + 1] = y;
          pa[6 * i + 2] = z;
          pa[6 * i + 3] = x;
          pa[6 * i + 4] = y;
          pa[6 * i + 5] = z;

          va[2 * i] = 0;
          va[2 * i + 1] = 0;
        }
      }

      pos.needsUpdate = true;
      renderer.render(scene, camera);
      requestAnimationFrame(animateParticles);
    };

    initParticles();

    return () => {
      // Cleanup
      window.removeEventListener("resize", onWindowResize);
      renderer?.dispose();
      document.body.removeChild(renderer.domElement);
    };
  }, []);

  const handleLogin = async () => {
    const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    if (userName.trim() === "" || password.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng nhập",
        text: "Vui lòng điền đầy đủ thông tin",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    } else if (userName.trim() != "" || password.trim() != "") {
      try {
        Swal.fire({
          title: "Đang xử lý...",
          text: "Vui lòng đợi giây lát",
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        // Chờ 3 giây
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await axios
          .post(`${process.env.REACT_APP_URL_API}/auth/login`, {
            username: userName,
            password,
          })
          .then((data) => {
            if (data.status === 201 && data.data.user.role === "SUPERADMIN" || data.data.user.role === "ADMIN") {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              navagate("/admin");
            } else {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                text: "Vui lòng đợi ít phút. ",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              navagate("/");
            }

            
            localStorage.setItem(
              "user_info",
              JSON.stringify({
                userName: data.data.user.username,
                coins: data.data.user.coins,
                role: data.data.user.role,
                id: data.data.user._id,
                phone: data.data.user.phone,
              })
            );

            Cookies.set("access_token", data.data.access_token, {
              expires: 1 / 24,
              secure: true,
              sameSite: "Strict",
            });
          })
          .catch((err) => {
            if (err.status === 401) {
              Swal.fire({
                icon: "error",
                title: "Lỗi đăng nhập",
                text: "Tài khoản/mật khẩu không chính xác!",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
            }
          });
      } catch (error) {
        return error;
      }
    }
  };

  return (
    <div className="login-page ">
      <div className="bgLogin"></div>
      <div
        className={`model-group ${
          isShowLoginForm || isRegister || isLogin ? "active" : ""
        }`}
      >
        <div className="overlay"></div>

        {/* Login Modal */}
        <div
          className={`model-item model-login ${
            isShowLoginForm || isLogin ? "model-login_active" : ""
          }  `}
        >
          <div
            className="btn-closeModel"
            onClick={() => {
              setIsShowLoginForm(false);
              setIsLogin(false);
            }}
          ></div>
          <p className="miniTxt">Đăng nhập</p>

          <div className="wrapper">
            <div className="title mb-2"></div>
            <form id="loginform" onSubmit={handleLogin}>
              <input
                className="bg-input mb-3"
                type="text"
                id="txtUsername"
                placeholder="Tên đăng nhập"
                onChange={(e) => setUserName(e.target.value)}
                maxLength={16}
                minLength={4}
                autoComplete="off"
                required
              />
              <input
                className="bg-input mb-3"
                type="password"
                id="txtPassword"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mật khẩu"
                maxLength={16}
                minLength={4}
                autoComplete="off"
                required
              />
              <div className="group-btn mt-4">
                <button type="button" className="btn-cancel"></button>
                <button
                  type="button"
                  className="btn-confirm"
                  onClick={handleLogin}
                ></button>
              </div>
            </form>
            <p className="txt-swith">
              Chưa có tài khoản?{" "}
              <span
                className="link-register"
                onClick={() => {
                  setIsShowLoginForm(false);
                  setIsRegister(true);
                }}
              >
                Đăng ký ngay
              </span>
            </p>
          </div>
          <p className="text-center text-sm"
          style={{color: 'white', padding: '0px 20px 20px 20px'}}
          >Bộ công thức này sẽ biến động và cập nhật theo từng ngày, vậy nên để đưa ra được kết quả chính xác nhất các bạn cần phải có sự kết hợp với các ADM để chọn ra bàn có tỷ lệ chuẩn nhất</p>
        </div>

        {/* Register Modal */}
        <Register
          isRegister={isRegister}
          setIsShowLogin={() => setIsLogin(true)}
          setIsRegister={() => setIsRegister(false)}
        />
      </div>

      <div className="index-page_wrapper">
        <div id="bg-canvas">
          <canvas
            className="particles-js-canvas-el"
            width="1366"
            height="641"
          ></canvas>
        </div>
        <div className="logo">
          <img
            src="assets/LogoMax.png"
            alt="Logo"
            className="logo_main"
          />
          <div className="wrapper-content">
            <div className="group-btn">
              <div
                className="btn-item btn-login"
                onClick={() => {
                  setIsShowLoginForm(true);
                }}
              ></div>
              <div
                className="btn-item btn-register"
                onClick={() => {
                  setIsRegister(true);
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
